






























































































































































import {
  computed, defineComponent, reactive, ref,
} from '@vue/composition-api';
import { useFormat } from 'vivat';
import { useQuery, useResult } from '@vue/apollo-composable';

import useHighChartMap from '@/useHighChartMap';

import getFailedDeliveryCost from '@/gql/report/analytic/getFailedDeliveryCost.gql';

import Heatmap from '@/components/Map/Heatmap.vue';
import CommonIconTop from '@/components/CommonIconTop.vue';

const NOW = new Date();
const ExpenseByFailedTransfer = defineComponent({
  components: {
    Heatmap,
    CommonIconTop,
  },
  setup() {
    const { getProperty } = useHighChartMap();
    const toDate = (date: string) => useFormat.date(date).displayFullThaiDate();
    const toCurrency = (string: string) => parseFloat(string || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    const getYear = (date: string) => useFormat.date(date).dayjs.get('year');
    const backwardTenYear = Array.from({ length: 10 }, (x, i) => new Date().getFullYear() + 543 - i);
    const filter = reactive({
      range: {
        from: useFormat.date(NOW).dayjs.startOf('year').format('YYYY-MM-DD'),
        to: useFormat.date(NOW).dayjs.endOf('year').format('YYYY-MM-DD'),
      },
    });
    const computedFilter = computed(() => {
      if (filter.range.from === filter.range.to) return {};
      return {
        range: {
          from: useFormat.date(filter.range.from).computerShortDate(),
          to: useFormat.date(filter.range.to).computerShortDate(),
        },
      };
    });
    const donutType = [
      { display: 'แบ่งตามสาขา (บาท)', name: 'hub' },
      { display: 'แบ่งตามพื้นที่จัดส่ง (บาท)', name: 'area' },
    ];
    const secondDonutType = [
      { display: 'แบ่งตามจังหวัด (บาท)', name: 'province' },
      { display: 'แบ่งตามสาเหตุ (บาท)', name: 'reason' },
    ];

    const { result: getFailedDeliveryCostResult } = useQuery(getFailedDeliveryCost, () => ({
      timeframe: computedFilter.value.range,
    }));
    const total = useResult(getFailedDeliveryCostResult, 0.00, (data) => data.failedDeliveryCost.deliveryCost);
    const deliveryFee = useResult(getFailedDeliveryCostResult, 0.00, (data) => data.failedDeliveryCost.deliveryFee);
    const price = useResult(getFailedDeliveryCostResult, 0.00, (data) => data.failedDeliveryCost.price);
    const weight = useResult(getFailedDeliveryCostResult, 0.00, (data) => data.failedDeliveryCost.weight);
    const volume = useResult(getFailedDeliveryCostResult, 0.00, (data) => data.failedDeliveryCost.volume);
    const reasonCostsGroupByMonth = useResult(getFailedDeliveryCostResult, [], (data) => data.failedDeliveryCost.reasonCostsGroupByMonth);
    const reasonCosts = useResult(getFailedDeliveryCostResult, [], (data) => data.failedDeliveryCost.reasonCosts);
    const reasons = useResult(getFailedDeliveryCostResult, [], (data) => data.failedDeliveryCost.reasons);
    const months = useResult(getFailedDeliveryCostResult, [], (data) => data.failedDeliveryCost.monthly);
    const provinces = useResult(getFailedDeliveryCostResult, [], (data) => data.failedDeliveryCostTopProvinces);
    const hubs = useResult(getFailedDeliveryCostResult, [], (data) => data.failedDeliveryCostTopHubs);
    const areas = useResult(getFailedDeliveryCostResult, [], (data) => data.failedDeliveryCostTopAreas);
    const topReasons = useResult(getFailedDeliveryCostResult, [], (data) => data.failedDeliveryCostTopReasons);

    const thMonthsMini = ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'];
    const selectedYear = ref(new Date().getFullYear() + 543);
    const computedSeriesData = computed(() => months.value.map((val: any) => ({
      x: thMonthsMini[val.month - 1],
      y: val.amount,
    })));
    const areaCharts = computed(() => ({
      options: {
        dataLabels: { enabled: false },
        yaxis: {
          opposite: false,
          labels: {
            formatter: (val: any) => toCurrency(val),
          },
        },
      },
      series: [
        {
          name: 'ค่าขนส่ง ที่จัดส่งไม่สำเร็จ (บาท)',
          data: computedSeriesData.value,
        },
      ],
    }));

    // TODO : Change to correct logic
    const computedReasonData = computed(() => {
      const result: any[] = [];
      const hitReasons: string[] = [];
      if (reasonCostsGroupByMonth.value.length === 0) return [];
      reasonCostsGroupByMonth.value.forEach((reasonMonth: { amount: number; month: number; reason: string }) => {
        const hitIndex = hitReasons.indexOf(reasonMonth.reason);
        if (hitIndex > -1) {
          result[hitIndex].push({
            x: thMonthsMini[reasonMonth.month - 1],
            y: reasonMonth.amount,
          });
        } else {
          hitReasons.push(reasonMonth.reason);
          result.push([{
            x: thMonthsMini[reasonMonth.month - 1],
            y: reasonMonth.amount,
          }]);
        }
      });

      return hitReasons.map((reason: string, index: number) => ({
        name: reason,
        data: result[index],
      }));
    });
    const reasonAreaCharts = computed(() => ({
      options: {
        dataLabels: { enabled: false },
        yaxis: {
          opposite: false,
          labels: {
            formatter: (val: any) => toCurrency(val),
          },
        },
      },
      series: computedReasonData.value,
    }));

    const colorIndex = ref(0);
    const COLORS = ['pink', 'green', 'blue', 'yellow', 'red', 'gray', 'orange', 'teal', 'indigo', 'purple'];
    function getColor() {
      if (colorIndex.value === 9) colorIndex.value = 0;
      else colorIndex.value += 1;
      return COLORS[colorIndex.value];
    }

    const donutChart = computed(() => {
      let area: any = [];
      if (areas.value.length === 0) area = [];
      else {
        const newAreaArray = areas.value;
        area = newAreaArray
          .map((elm: any) => elm)
          .sort((elm: any, elm2: any) => elm2.deliveryCost - elm.deliveryCost);

        const top5 = area.slice(0, 5).map((elm: any) => ({
          name: elm.name,
          data: elm.deliveryCost,
          packagePrice: elm.packagePrice,
          color: getColor(),
        }));

        const totalOther = area
          .slice(5)
          .reduce((previousValue: any, currentValue: any) => previousValue + currentValue.deliveryCost, 0);

        area = [
          ...top5,
          { name: 'อื่น ๆ', data: totalOther, color: getColor() },
        ];
      }

      let hub: any = [];
      if (hubs.value.length === 0) hub = [];
      else {
        const newHubArray = hubs.value;
        hub = newHubArray
          .map((elm: any) => elm)
          .sort((elm: any, elm2: any) => elm2.deliveryCost - elm.deliveryCost);

        const top5 = hub.slice(0, 5).map((elm: any) => ({
          name: elm.name,
          data: elm.deliveryCost,
          packagePrice: elm.packagePrice,
          color: getColor(),
        }));

        const totalOther = hub
          .slice(5)
          .reduce((previousValue: any, currentValue: any) => previousValue + currentValue.deliveryCost, 0);

        hub = [
          ...top5,
          { name: 'อื่น ๆ', data: totalOther, color: getColor() },
        ];
      }

      let province: any = [];
      if (provinces.value.length === 0) province = [];
      else {
        const newArray = provinces.value;
        province = newArray
          .map((elm: any) => elm)
          .sort((elm: any, elm2: any) => elm2.deliveryCost - elm.deliveryCost);

        const top5 = province.slice(0, 5).map((elm: any) => ({
          name: elm.name,
          data: elm.deliveryCost,
          packagePrice: elm.packagePrice,
          color: getColor(),
        }));

        const totalOther = province
          .slice(5)
          .reduce((previousValue: any, currentValue: any) => previousValue + currentValue.deliveryCost, 0);

        province = [
          ...top5,
          { name: 'อื่น ๆ', data: totalOther, color: getColor() },
        ];
      }

      let reason: any = [];
      if (reasons.value.length === 0) reason = [];
      else {
        const newArray = reasons.value;
        reason = newArray
          .map((elm: any) => elm)
          .sort((elm: any, elm2: any) => elm2.deliveryCost - elm.deliveryCost);

        const top5 = reason.slice(0, 5).map((elm: any) => ({
          name: elm.reason,
          data: elm.count,
          color: getColor(),
        }));

        const totalOther = reason
          .slice(5)
          .reduce((previousValue: any, currentValue: any) => previousValue + currentValue.deliveryCost, 0);

        reason = [
          ...top5,
          { name: 'อื่น ๆ', data: totalOther, color: getColor() },
        ];
      }

      return {
        hub,
        area,
        province,
        reason,
      };
    });

    const computedData = computed(() => {
      const _value: any = {
        northern: [],
        northeastern: [],
        central: [],
        eastern: [],
        western: [],
        southern: [],
      };

      function pushToArray(_region: string, province: string | number, value: number | string) {
        if (_region === 'NORTHERN') _value.northern.push([`th-${province}`, value]);
        else if (_region === 'NORTHEASTERN') _value.northeastern.push([`th-${province}`, value]);
        else if (_region === 'CENTRAL') _value.central.push([`th-${province}`, value]);
        else if (_region === 'EASTERN') _value.eastern.push([`th-${province}`, value]);
        else if (_region === 'WESTERN') _value.western.push([`th-${province}`, value]);
        else if (_region === 'SOUTHERN') _value.southern.push([`th-${province}`, value]);
      }

      const hasValue: number[] = [];
      provinces.value.forEach((elm: any) => {
        hasValue.push(elm.provinceId);
        const { shortForm, region } = getProperty(elm.provinceId);
        pushToArray(region, shortForm, elm.deliveryCost);
      });
      for (let i = 0; i < 78; i += 1) {
        if (hasValue.indexOf(i) === -1) {
          const { shortForm, region } = getProperty(i);
          pushToArray(region, shortForm, 0);
        }
      }
      return _value;
    });

    const computedTopReasons = computed(() => {
      let reasonPackages: any = [];
      const hitReasons: string[] = [];
      if (topReasons.value.length === 0) reasonPackages = [];
      topReasons.value.forEach((reason: { failureReason: string; packageName: string; deliveryCost: number; packagePrice: number }) => {
        const hitIndex = hitReasons.indexOf(reason.failureReason);
        if (hitIndex > -1) {
          reasonPackages[hitIndex].totalCost += reason.deliveryCost;
          reasonPackages[hitIndex].packages.push({
            packageName: reason.packageName, deliveryCost: reason.deliveryCost, packagePrice: reason.packagePrice,
          });
        } else {
          hitReasons.push(reason.failureReason);
          reasonPackages.push({
            reason: reason.failureReason,
            totalCost: reason.deliveryCost,
            packages: [{
              packageName: reason.packageName, deliveryCost: reason.deliveryCost, packagePrice: reason.packagePrice,
            }],
          });
        }
      });

      return reasonPackages.sort((elm: any, elm2: any) => elm2.totalCost - elm.totalCost).slice(0, 3).map((rp: any) => ({
        reason: rp.reason,
        packages: rp.packages.sort((elm: any, elm2: any) => elm2.deliveryCost - elm.deliveryCost).slice(0, 5),
      })) || [];
    });

    return {
      toCurrency,
      toDate,
      getYear,
      filter,

      donutType,
      areaCharts,
      donutChart,
      secondDonutType,
      backwardTenYear,
      selectedYear,

      computedData,
      reasonAreaCharts,

      computedTopReasons,
      deliveryFee,
      price,
      weight,
      volume,
    };
  },
});

export default ExpenseByFailedTransfer;
